(function () {
  const descriptions = {
    'シューズモリ本店': '歩きやすさと装いの両立を大切に、足のお悩みも相談しやすい浜町の本店です。',
    'モード・エ・ジャコモ ブティック': '上品さと今の気分を取り入れた、レディースシューズとバッグを揃えるブティックです。',
    'ハッシュパピー長崎店': 'カジュアルシューズを中心に、メンズ・レディースともに毎日に取り入れやすい靴を提案しています。',
    'アピエ202': '20.5cmから21.5cm、25.0cmから26.5cmを中心に、小さいサイズ・大きいサイズの婦人靴を扱う専門店です。',
    'アピエ２０２': '20.5cmから21.5cm、25.0cmから26.5cmを中心に、小さいサイズ・大きいサイズの婦人靴を扱う専門店です。',
  };

  const imageAlt = {
    'シューズモリ本店': 'シューズモリ本店 外観',
    'モード・エ・ジャコモ ブティック': 'モード・エ・ジャコモ ブティック 外観',
    'ハッシュパピー長崎店': 'ハッシュパピー長崎店 店内',
    'アピエ202': 'アピエ202 外観',
    'アピエ２０２': 'アピエ202 外観',
  };

  const normalize = (value) => value.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();

  const normalizedUrl = (value) => {
    try {
      const url = new URL(value, window.location.origin);
      return `${url.origin}${url.pathname.replace(/\/+$/, '') || '/'}`;
    } catch (_error) {
      return '';
    }
  };

  const getCopy = (source) => ({
    corporateSiteUrl: source.dataset.corporateSiteUrl || '',
    corporateSiteLabel: source.dataset.corporateSiteLabel || '',
    storesHeading: source.dataset.storesHeading || '',
    storeImageAlt: source.dataset.storeImageAlt || '',
    addressLabel: source.dataset.addressLabel || '',
    storeDetailsLabel: source.dataset.storeDetailsLabel || '',
    storeProductsLabel: source.dataset.storeProductsLabel || '',
  });

  function nodeTextWithoutLinks(node) {
    const clone = node.cloneNode(true);
    clone.querySelectorAll('a, img').forEach((child) => child.remove());
    return normalize(clone.textContent || '');
  }

  function buttonLink(href, label, isSecondary) {
    const link = document.createElement('a');
    link.className = `button ${isSecondary ? 'button--secondary ' : ''}about-store-card__button`;
    link.href = href;
    link.textContent = label;
    return link;
  }

  function enhanceIntro(intro, copy) {
    const lead = intro.querySelector('h2');
    if (lead) {
      lead.id = 'about-intro-title';
      lead.className = 'about-page__lead';
      intro.setAttribute('aria-labelledby', lead.id);
    }

    intro.querySelectorAll('a[href]').forEach((link) => {
      const parentText = normalize(link.parentElement ? link.parentElement.textContent : '');
      const linkText = normalize(link.textContent);
      const isStandaloneCorporateLink =
        copy.corporateSiteUrl &&
        normalizedUrl(link.href) === normalizedUrl(copy.corporateSiteUrl) &&
        parentText === linkText;

      if (!isStandaloneCorporateLink) return;

      link.className = 'button button--secondary about-page__corporate-link';
      link.textContent = copy.corporateSiteLabel;
    });
  }

  function buildStoreCard(store, copy) {
    const card = document.createElement('article');
    card.className = 'about-store-card';

    const body = document.createElement('div');
    body.className = 'about-store-card__body';

    const title = document.createElement('h3');
    title.className = 'about-store-card__title';
    title.textContent = store.title;

    const image = store.nodes
      .map((node) => {
        if (node.matches && node.matches('img')) return node;
        return node.querySelector ? node.querySelector('img') : null;
      })
      .find(Boolean);

    if (image) {
      const imageWrap = document.createElement('div');
      imageWrap.className = 'about-store-card__image';
      if (!image.hasAttribute('loading')) {
        image.loading = 'lazy';
      }
      if (!normalize(image.alt || '')) {
        image.alt = imageAlt[store.title] || `${store.title} ${copy.storeImageAlt}`.trim();
      }
      imageWrap.appendChild(image);
      card.appendChild(imageWrap);
    }

    body.appendChild(title);

    if (descriptions[store.title]) {
      const description = document.createElement('p');
      description.className = 'about-store-card__text';
      description.textContent = descriptions[store.title];
      body.appendChild(description);
    }

    const links = store.nodes.flatMap((node) => Array.from(node.querySelectorAll ? node.querySelectorAll('a[href]') : []));
    const detailLink = links.find((link) => link.href.includes('shoes-mori.co.jp/shoplist/'));
    const productsLink = links.find((link) => link.href.includes('shoes-mori.biz/collections/'));
    const textRows = store.nodes
      .map(nodeTextWithoutLinks)
      .filter(Boolean);
    const address = textRows.find((text) => !/^TEL/i.test(text));
    const tel = textRows.find((text) => /^TEL/i.test(text));

    if (address || tel) {
      const details = document.createElement('dl');
      details.className = 'about-store-card__details';

      if (address) {
        const row = document.createElement('div');
        row.innerHTML = '<dt></dt><dd></dd>';
        row.querySelector('dt').textContent = copy.addressLabel;
        row.querySelector('dd').textContent = address;
        details.appendChild(row);
      }

      if (tel) {
        const row = document.createElement('div');
        row.innerHTML = `<dt>TEL</dt><dd></dd>`;
        row.querySelector('dd').textContent = tel.replace(/^TEL[\s\u3000]*/i, '');
        details.appendChild(row);
      }

      body.appendChild(details);
    }

    if (detailLink || productsLink) {
      const actions = document.createElement('div');
      actions.className = 'about-store-card__actions';

      if (detailLink) {
        actions.appendChild(buttonLink(detailLink.href, copy.storeDetailsLabel, true));
      }

      if (productsLink) {
        actions.appendChild(buttonLink(productsLink.href, copy.storeProductsLabel, false));
      }

      body.appendChild(actions);
    }

    card.appendChild(body);
    return card;
  }

  function enhanceAboutPage(scope = document) {
    const source = scope.matches?.('[data-about-page-source]')
      ? scope
      : scope.querySelector('[data-about-page-source]');
    if (!source || source.dataset.aboutEnhanced === 'true') return;

    const copy = getCopy(source);
    const children = Array.from(source.children);
    const firstStoreCardIndex = children.findIndex((child) => child.matches('h3'));
    const storesHeading =
      children.find((child) => child.matches('h2') && normalize(child.textContent) === normalize(copy.storesHeading)) ||
      (firstStoreCardIndex === -1
        ? null
        : children
            .slice(0, firstStoreCardIndex)
            .reverse()
            .find((child) => child.matches('h2')));
    if (!storesHeading) return;

    const intro = document.createElement('section');
    intro.className = 'about-page__intro';

    const storesSection = document.createElement('section');
    storesSection.className = 'about-page__stores';
    storesSection.setAttribute('aria-labelledby', 'about-stores-title');

    const grid = document.createElement('div');
    grid.className = 'about-store-grid';

    let currentStore = null;
    const stores = [];

    children.forEach((child) => {
      if (child === storesHeading) {
        child.id = 'about-stores-title';
        child.className = 'about-page__stores-title';
        storesSection.appendChild(child);
        return;
      }

      if (!storesSection.contains(storesHeading)) {
        intro.appendChild(child);
        return;
      }

      if (child.matches('h3')) {
        const title = normalize(child.textContent);
        if (!title) {
          if (currentStore && child.querySelector('img')) {
            currentStore.nodes.push(child);
          }
          return;
        }
        currentStore = { title, nodes: [] };
        stores.push(currentStore);
        return;
      }

      if (currentStore) {
        currentStore.nodes.push(child);
      }
    });

    enhanceIntro(intro, copy);
    stores.forEach((store) => grid.appendChild(buildStoreCard(store, copy)));
    storesSection.appendChild(grid);

    source.classList.remove('rte');
    source.dataset.aboutEnhanced = 'true';
    source.replaceChildren(intro, storesSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceAboutPage);
  } else {
    enhanceAboutPage();
  }

  document.addEventListener('shopify:section:load', (event) => enhanceAboutPage(event.target));
})();
